import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://mbytmdgpjfbybwojbvih.supabase.co'
const supabaseKey = 'sb_publishable_QZ9olGQQjWNcPxx-ioT4IQ_ZC5Js5pK'
export const supabase = createClient(supabaseUrl, supabaseKey)